import React from "react";
import "./style.scss";
import ReviewBatchList from "../../../components/Review/ReviewBatchList";

const ReviewBatchListPage = () => {
  return (
    <div className="review_batch_list_page_wrapper">
      <ReviewBatchList />
    </div>
  );
};
export default ReviewBatchListPage;
